module.exports = __webpack_public_path__ + "static/homepage-hero-1e6df9828b8bcb9d5284acb08dde3b1b.jpg";